import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback
} from "reactstrap"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import swal from "sweetalert"
import { createPayement } from "helpers/requests"


const CreatePayment = (props) => {
  const [payment, setPayment] = useState({
    firstname: "",
    lastname: "",
    phonenumber: "",
    email: "",
    amount: "",
    type: "RESERVATION"
  })

  const [errors, setErrors] = useState({})

  // Validate form fields
  const validateForm = () => {
    const newErrors = {}

    if (!payment.firstname.trim()) {
      newErrors.firstname = "First name is required"
    }

    if (!payment.lastname.trim()) {
      newErrors.lastname = "Last name is required"
    }

    if (!payment.phonenumber.trim()) {
      newErrors.phonenumber = "Phone number is required"
    } else if (!/^\+?[0-9]{10,14}$/.test(payment.phonenumber)) {
      newErrors.phonenumber = "Invalid phone number format"
    }

    if (payment.email && !/\S+@\S+\.\S+/.test(payment.email)) {
      newErrors.email = "Invalid email format"
    }

    if (!payment.amount || isNaN(Number(payment.amount)) || Number(payment.amount) <= 0) {
      newErrors.amount = "Valid amount is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setPayment(prevState => ({
      ...prevState,
      [name]: value
    }))
  }

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validate form
    if (!validateForm()) {
      return
    }

    try {
      // Convert amount to decimal
      const paymentData = {
        ...payment,
        amount: Number(payment.amount)
      }
    
      // Call API to create payment
       await createPayement(paymentData)

      // Show success message
      swal({
        title: "Payment Created",
        text: "Payment has been successfully created!",
        icon: "success",
        button: "Continue"
      }).then(() => {
        
        window.location.href ='/payments'
        
        setPayment({
          firstname: "",
          lastname: "",
          phonenumber: "",
          email: "",
          amount: "",
          type: "RESERVATION"
        })
      })
    } catch (error) {
      // Handle API errors
      swal({
        title: "Error",
        text: error.message || "Unable to create payment. Please try again.",
        icon: "error",
        button: "OK"
      })
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs 
          title={props.t("Payments")} 
          breadcrumbItem={props.t("Create Payment")} 
        />
        
        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <CardTitle className="mb-4">Create New Payment</CardTitle>
                
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>First Name</Label>
                        <Input
                          type="text"
                          name="firstname"
                          value={payment.firstname}
                          onChange={handleInputChange}
                          invalid={!!errors.firstname}
                        />
                        {errors.firstname && (
                          <FormFeedback>{errors.firstname}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Last Name</Label>
                        <Input
                          type="text"
                          name="lastname"
                          value={payment.lastname}
                          onChange={handleInputChange}
                          invalid={!!errors.lastname}
                        />
                        {errors.lastname && (
                          <FormFeedback>{errors.lastname}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Phone Number</Label>
                        <Input
                          type="tel"
                          name="phonenumber"
                          value={payment.phonenumber}
                          onChange={handleInputChange}
                          invalid={!!errors.phonenumber}
                        />
                        {errors.phonenumber && (
                          <FormFeedback>{errors.phonenumber}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Email (Optional)</Label>
                        <Input
                          type="email"
                          name="email"
                          value={payment.email}
                          onChange={handleInputChange}
                          invalid={!!errors.email}
                        />
                        {errors.email && (
                          <FormFeedback>{errors.email}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Payment Amount</Label>
                        <Input
                          type="number"
                          name="amount"
                          step="0.01"
                          value={payment.amount}
                          onChange={handleInputChange}
                          invalid={!!errors.amount}
                        />
                        {errors.amount && (
                          <FormFeedback>{errors.amount}</FormFeedback>
                        )}
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Payment Type</Label>
                        <Input
                          type="select"
                          name="type"
                          value={payment.type}
                          onChange={handleInputChange}
                        >
                          <option value="RESERVATION">Reservation</option>
                          <option value="HOTEL_RESERVATION">Hotel Reservation</option>
                          <option value="VISA">Visa</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Button color="primary" type="submit" className="mt-3">
                        Create Payment
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

CreatePayment.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(CreatePayment)